import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { INPUT_DATE_FORMAT } from '../constants/periodDateInput.constant';

dayjs.extend(customParseFormat);

/**
 * Reads what the user typed in a date input, or null when it is not a complete valid date.
 */
export function parseInputDate(raw: string): Dayjs | null {
  const date = dayjs(raw.trim(), INPUT_DATE_FORMAT, true);

  return date.isValid() ? date.startOf('day') : null;
}

/**
 * Writes a date back into the input's display format.
 */
export function formatInputDate(date: Dayjs): string {
  return date.format(INPUT_DATE_FORMAT);
}
